import React, { useState } from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs'
import { PaymentIntentForm } from '../../components/test-checkout/payment-intent-form'
import { TestScenarios, TestScenario } from '../../components/test-checkout/test-scenarios'
import { PaymentIntentResponse } from '@/lib/api/generated/models'
import { PaymentResponseModal } from '@/components/test-checkout/response-modal'
import { PaymentSDKContainer } from '@/components/payment-sdk/payment-sdk-container'

export function TestCheckoutPage() {
  const [showResponseModal, setShowResponseModal] = useState(false)
  const [apiResponse, setApiResponse] = useState<PaymentIntentResponse | null>(null)
  const [scenarioData, setScenarioData] = useState<TestScenario['data'] | undefined>(undefined)
  const [activeTab, setActiveTab] = useState('form')

  const handlePaymentIntentCreated = (response: PaymentIntentResponse) => {
    setApiResponse(response)
    setShowResponseModal(true)
  }

  const handleLoadScenario = (scenario: TestScenario['data']) => {
    setScenarioData(scenario)
    setActiveTab('form')
  }
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold">QA Test Checkout Page</h1>
              <p className="text-muted-foreground">Test the order creation API with comprehensive form inputs</p>
            </div>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-8">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="form">Payment Form</TabsTrigger>
            <TabsTrigger value="scenarios">Test Scenarios</TabsTrigger>
          </TabsList>

          <TabsContent value="form" className="space-y-6">
            <Card>
              <CardHeader>
                <CardTitle>Payment Intent Creation</CardTitle>
                <CardDescription>Fill out the form below to test the payment intent creation API</CardDescription>
              </CardHeader>
              <CardContent>
                <PaymentIntentForm onPaymentIntentCreated={handlePaymentIntentCreated} scenarioData={scenarioData} />
              </CardContent>
            </Card>

            {apiResponse?.sessionId && (
              <Card>
                <CardHeader>
                  <CardTitle>Payment SDK</CardTitle>
                  <CardDescription>Complete the payment using the SDK below</CardDescription>
                </CardHeader>
                <CardContent>
                  <PaymentSDKContainer sessionId={apiResponse.sessionId} environment="sandbox" />
                  {/* Payment container - must exist in DOM before SDK initializes */}
                  <div id="payment-container" style={{ display: 'none', minHeight: '500px' }} />
                </CardContent>
              </Card>
            )}
          </TabsContent>

          <TabsContent value="scenarios" className="space-y-6">
            <Card>
              <CardHeader>
                <CardTitle>Test Scenarios</CardTitle>
                <CardDescription>Quick-load common test scenarios</CardDescription>
              </CardHeader>
              <CardContent>
                <TestScenarios onLoadScenario={handleLoadScenario} />
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </main>
      <PaymentResponseModal open={showResponseModal} onOpenChange={setShowResponseModal} response={apiResponse} />
    </div>
  )
}
